var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { width: "600px" },
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_BatchEnterModifyBusinessOrderNo"),
        visible: _vm.innerVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDocNoP") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { no: "1" },
                model: {
                  value: _vm.txtNo,
                  callback: function($$v) {
                    _vm.txtNo = $$v
                  },
                  expression: "txtNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("CargoMsg.Cargo_WriteOffStartingPeriodP") }
            },
            [
              _c("el-checkbox", {
                attrs: { no: "2" },
                model: {
                  value: _vm.chkInit,
                  callback: function($$v) {
                    _vm.chkInit = $$v
                  },
                  expression: "chkInit"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { no: "3" }, on: { click: _vm.saveClickHandler } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "4" }, on: { click: _vm.closeHandler } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }